import * as React from 'react';
export const trustmarknationalSvg = React.forwardRef(
  function trustmarknationalSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#006BB5',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M5 13.966v5.125l11.133 7.23 10.86-7.642v-5.655L16.236 6 5 13.966Z',
        fill: '#fff',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'm18.113 7.23-1.98 1.376v-.405l-2.379 1.672-4.594 3.254-3.542 2.526c-.198.14-.42.301-.618.434v-.42l.84-.596 6.78-4.83 4.875-3.424.625.413h-.007Zm1.274.832-3.255 2.275v-.42l-7.465 5.287L5 17.81v-.42l9.844-6.994 3.91-2.747.633.413ZM5.044 19.091l1.782-1.281L17.2 10.47l2.827-1.996.626.412-4.52 3.18v-.426l-6.2 4.395v.92l-1.149.833-2.753 1.944-.987-.641Zm1.266.825 15-10.603.618.405-5.794 4.072v-.412l-6.2 4.388v.913l-2.643 1.87-.98-.633Zm1.267.824 6.641-4.704 8.357-5.898.626.412-7.068 4.977V15.1l-6.2 4.389v.913l-1.384.971-.972-.633Zm1.259.818L23.84 10.963l.619.405-8.328 5.868v-.413l-6.199 4.381v1.075l-1.097-.721Zm1.259.824 15.02-10.588.626.405-4.278 3.005-4.852 3.423.36.236-5.89 4.16-.986-.64Zm1.259.825 15.02-10.595.626.412-4.16 2.93.36.236-.971.7v-.509l-4.351 3.07.36.236-5.89 4.168-.994-.648Zm1.274.825 9.748-6.877 4.55-3.203.052-.037v.832l-2.886 2.025.382.25-2.245 1.568v-.508l-3.093 2.194.369.244-5.89 4.16-.987-.648Zm1.266.824 10.838-7.642 2.246-1.576v.832l-1.62 1.134.376.243-3.505 2.466v-.515l-1.84 1.303.375.243-5.883 4.16-.987-.648Zm1.259.824 9.012-6.353 2.813-1.974v.825l-.346.258.368.243-4.771 3.342v-.515c-.162.118-.405.302-.575.427l.361.243-5.883 4.153-.979-.64v-.008ZM16.84 6.398c-.229.162-.472.33-.707.5v-.397l-3.719 2.613-5.176 3.675L5 14.386v-.42l5.625-4.02L16.228 6l.611.398Z',
        fill: '#006BB5',
      }),
    );
  },
);
trustmarknationalSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var trustmarknational = {
  category: 'brand',
  colorable: false,
  name: 'trustmarknational',
  svg: trustmarknationalSvg,
};
